import React, { useEffect, useState,useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { db, auth } from '../firebase';
import { doc, getDoc, query, where, getDocs, collection,addDoc,orderBy,
  startAt,
  endAt,
  limit, startAfter} from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

import { useLocation } from 'react-router-dom';
import { trackClick } from './trackClick';

import Layout from "../components/layout/Layout"; 

import BackHomeButton from '../components/BackHomeButton';
import Get_Help from '../components/Get_Help';
import Help_Video from '../components/Help_Video';

import {updateDoc, increment, setDoc } from 'firebase/firestore';
import { getStorage, ref, listAll, getDownloadURL } from 'firebase/storage';
import AutoScrollPreview from "../components/AutoScrollPreview";
import { ChevronDown,  FilePlus,
  Brain,
  PenLine,
  BookOpen,
  CheckCircle2,User,Bot, Wallet, Headset ,Send
 } from 'lucide-react';

function Old_Home() {
  const navigate = useNavigate();

  const location = useLocation();

  const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

  const pageSize = isMobile ? 10 : 20;
  const [visibleCount, setVisibleCount] = useState(pageSize);
  const [carouselImages, setCarouselImages] = useState([]);

  const [profileExists, setProfileExists] = useState(false);
  const [schoolFeedbackExists, setSchoolFeedbackExists] = useState(false);
  const [userName, setUserName] = useState('');
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const [loadingForms, setLoadingForms] = useState(true);


const [lastUploadsDoc, setLastUploadsDoc] = useState(null);
const [lastAiDoc, setLastAiDoc] = useState(null);
const [hasMoreForms, setHasMoreForms] = useState(true);
const [loadingMoreForms, setLoadingMoreForms] = useState(false);

const [showEasyIntro, setShowEasyIntro] = useState(false);

const [easyQuestion, setEasyQuestion] = useState("");

const askEasy = (event) => {
  event.preventDefault();

  const text = easyQuestion.trim();
  if (!text) return;

  navigate("/EasyUnifiedChat", {
    state: {
      easyQuestion: {
        text,
        requestId: crypto.randomUUID(),
      },
    },
  });
};

useEffect(() => {
  const seen = sessionStorage.getItem("easy_ai_intro_seen");

  if (!seen) {
    setShowEasyIntro(true);
    sessionStorage.setItem("easy_ai_intro_seen", "true");
  }
}, []);

//const firestorePageSize = pageSize;
const firestoreFetchLimit = 100;

const getUploadOrderField = () => {
  if (sortOption === 'downloads') return 'downloads';
  if (sortOption === 'rating') return 'avgRating';
  return 'uploadTime';
};

const getAiOrderField = () => {
  if (sortOption === 'downloads') return 'retake_count';
  return 'timestamp';
};

const getStandardFilter = (profileData) => {
  if (selectedStandard === 'All_Standard') return null;
  if (selectedStandard === 'My_Standard') return profileData?.standard ? String(profileData.standard) : null;
  return String(selectedStandard);
};

const getSchoolFilter = (profileData) => {
  if (selectedSchool === 'All_Schools') return null;

  if (selectedSchool === 'My_School') {
    if (!profileData?.city || !profileData?.school) return null;
    return { city: profileData.city, school: profileData.school };
  }

  const [city, ...schoolParts] = selectedSchool.split(',');
  return {
    city: city.trim(),
    school: schoolParts.join(',').trim()
  };
};

  // --- LANGUAGE DROPDOWN LOGIC ---
  const [browserLang, setBrowserLang] = useState(localStorage.getItem('appLang') || 'en');



  const handleLanguageChange = (e) => {
    const selectedLang = e.target.value;
    setBrowserLang(selectedLang); 
    localStorage.setItem('appLang', selectedLang); 

    setTimeout(() => {
      const googleSelect = document.querySelector('.goog-te-combo');
      if (googleSelect) {
        googleSelect.value = selectedLang;
        googleSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }, 10);
  };
  // -------------------------------

  const [showSummary, setShowSummary] = useState(false);


    const [user, setUser] = useState(null);
    const [userProfile, setUserProfile] = useState(null);

    const [text, setText] = useState('');
    const [subject, setSubject] = useState('');
    const [lessonName, setLessonName] = useState('');
    const textAreaRef = useRef(null);
  
    const [savedLessons, setSavedLessons] = useState([]);
    const [selectedLessonId, setSelectedLessonId] = useState('');

    const [showRewardFlash, setShowRewardFlash] = useState(true);


      const [standard, setStandard] = useState('');
      const [school, setSchool] = useState('');
      const [board, setboard] = useState('');

      const[label,setlabel] = useState('');

        const getDeviceType = () => {
  const ua = navigator.userAgent;
  if (/iPad/i.test(ua)) return 'iPad';
  if (/iPhone/i.test(ua)) return 'iPhone';
  if (/Android/i.test(ua)) return 'Android';
  if (/Windows/i.test(ua)) return 'Windows Desktop';
  if (/Mac OS X/i.test(ua)) return 'Mac Desktop';
  if (/Linux/i.test(ua)) return 'Linux';
  return 'Other';
};

  // Hover state management
  const [hoveredBtn, setHoveredBtn] = useState(null);
  const [hoveredDrawerItem, setHoveredDrawerItem] = useState(null);
  const [hoveredButton, setHoveredButton] = useState(null);

const [downloadSummary, setDownloadSummary] = useState({});
const [loadingSummary, setLoadingSummary] = useState(true);


const [persona,setPersona]=useState(location.state?.persona || '');

const [recentActivity, setRecentActivity] = useState([]);

const [sharedCount, setSharedCount] = useState(0);

const [rewardCount, setRewardCount] = useState(0);

{/************************************* */}
  const [profile, setProfile] = useState(null);
  const [allForms, setAllForms] = useState([]);
  const [filteredForms, setFilteredForms] = useState([]);
  const [visibleForms,setVisibleForms] = useState([]);
  const [feedbackCounts, setFeedbackCounts] = useState({});
  const [userVotes, setUserVotes] = useState({});
  
  const [selectedType, setSelectedType] = useState(location.state?.type || 'All Types');
  const [selectedSchool, setSelectedSchool] = useState('My_School');
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(false);
  const [selectedStandard, setSelectedStandard] = useState('My_Standard');
  
  const [sortOption, setSortOption] = useState('newest');

 

  const [selectedSubject, setSelectedSubject] = useState('All Subjects');

  const [downloadedFileIds, setDownloadedFileIds] = useState([]);
  const [sharedFileIds, setSharedFileIds] = useState([]);
  const [hideShared, setHideShared] = useState(false);

 
  const [userStarRatings, setUserStarRatings] = useState({});

  const [openId, setOpenId] = useState(null);


  const subjects = ['All Subjects', ...new Set(allForms.map(f => f.subject))];

  const [citySchoolOptions, setCitySchoolOptions] = useState([]);

  useEffect(() => {
  const fetchCitySchools = async () => {
    try {
      const snapshot = await getDocs(collection(db, 'city_schools_prod'));

      const schools = snapshot.docs
        .map(docSnap => docSnap.data())
        .filter(item => item.city && item.school)
        .map(item => `${item.city}, ${item.school}`)
        .sort((a, b) => a.localeCompare(b));

      setCitySchoolOptions([...new Set(schools)]);
    } catch (error) {
      console.error('Error fetching city schools:', error);
    }
  };

  fetchCitySchools();
}, []);

  // ✅ Now creates a combined "City, School" string for the dropdown
   const uniqueCitySchools = citySchoolOptions;

   const schoolsWithForms = new Set(
  allForms
    .map(f => {
      if (f.city && f.school) return `${f.city}, ${f.school}`;
      if (f.school) return f.school;
      return '';
    })
    .filter(s => s && s.trim() !== '')
);

;
  // --- SEARCH AUTOCOMPLETE STATE ---
  const [allCreators, setAllCreators] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const searchWrapperRef = useRef(null);

  useEffect(() => {
  const showPremiumCampaign = sessionStorage.getItem("showPremiumCampaign");

  //alert(showPremiumCampaign);

  if (showPremiumCampaign) {
    setShowRewardFlash(false);
  }
}, []);
  

// 🔹 Close search dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchWrapperRef.current && !searchWrapperRef.current.contains(event.target)) {
        setSuggestions([]);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // 🔹 1. Fetch public profiles once on load
  useEffect(() => {
    const fetchCreators = async () => {
      try {
        const snapshot = await getDocs(collection(db, 'public_profiles'));
        setAllCreators(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
      } catch (error) { console.error("Error fetching creators:", error); }
    };
    fetchCreators();
  }, []);

// 🔹 2. Fast Local Search (Name OR Email)
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);

    if (value.trim().length > 1) {
      const lowerVal = value.toLowerCase();
      const matched = allCreators.filter(c => 
        (c.displayName || '').toLowerCase().includes(lowerVal) || 
        (c.school || '').toLowerCase().includes(lowerVal) ||
        (c.email || '').toLowerCase().includes(lowerVal) // Triggers on email
      );
      setSuggestions(matched.slice(0, 5));
    } else {
      setSuggestions([]);
    }
  };

// 🔹 3. Navigate straight to Creator Profile
  const handleSelectSuggestion = (creator) => {
    navigate(`/CreatorProfile/${creator.id}`);
  };

  // Total files after filters (before hiding downloaded)
//const totalFiles = filteredForms.length;

// How many of those filtered files are already downloaded
//const totalDownloaded = filteredForms.filter(form =>
//  downloadedFileIds.includes(form.fileLink)
//).length;

// Total left to download
//const totalLeft = totalFiles - totalDownloaded;

useEffect(() => {
  const fetchBanners = async () => {
    try {
      // 1. Reference your new 'banners' collection
      const bannersRef = collection(db, "banners");
      
      // 2. Query for banners that are either 'Online' or match the user's city
      // This ensures they see global ads + local school/city ads
      const q = query(
        bannersRef, 
        where("city", "in", ["Online", profile?.city || "Online"])
      );
      
      const querySnapshot = await getDocs(q);
      const bannerData = [];
      
      querySnapshot.forEach((doc) => {
        const data = doc.data();
        bannerData.push({
          image: data.imageUrl,
          link: data.targetUrl || "https://eascode.co.in" // Fallback link
        });
      });

      // 3. Shuffle so the order changes on every visit
      setCarouselImages(bannerData.sort(() => 0.5 - Math.random()));
    } catch (error) {
      console.error("Error fetching Firestore banners:", error);
    }
  };

  fetchBanners();
}, [profile?.city]);



useEffect(() => {
  const disableRightClick = (e) => {
    e.preventDefault();
  };

  document.addEventListener("contextmenu", disableRightClick);

  return () => {
    document.removeEventListener("contextmenu", disableRightClick);
  };
}, []);

const handleDownload = async (form) => {
    // Open the file immediately for the user
    window.open(form.fileLink, '_blank');

    const user = auth.currentUser;
    const currentDevice = getDeviceType();

    if (user) {
      try {
        // 1. Check how many times THIS user has downloaded THIS specific file
        const downloadCheckQuery = query(
          collection(db, 'Downloads_And_Generations'),
          where('userId', '==', user.uid),
          where('fileUrl', '==', form.fileLink),
          where('action', '==', 'Download')
        );
        
        const downloadSnap = await getDocs(downloadCheckQuery);
        const pastDownloads = downloadSnap.size;

        // 2. Only increment metrics if they downloaded it less than 2 times AND are not the creator
        if (pastDownloads < 2 && form.uid && form.uid !== user.uid) {
          
          // Update the UI immediately
          setFilteredForms(prev =>
            prev.map(f => f.id === form.id ? { ...f, downloads: f.downloads + 1 } : f)
          );

          // Increment file in 'uploads'
          const uploadRef = doc(db, 'uploads', form.id);
          await updateDoc(uploadRef, { downloads: increment(1) });

          // Increment creator's profile in 'public_profiles'
          const creatorProfileRef = doc(db, 'public_profiles', form.uid);
          await setDoc(
            creatorProfileRef,
            { totalDownloads: increment(1) },
            { merge: true }
          );

          // --- NEW: Capture the reward for the creator ---
          await addDoc(collection(db, 'Reward_Capture'), {
            uid: form.uid,
            // In your Old_Home.js, the 'uploadedBy' field often holds the email based on your data structure
            user_email: form.uploadedBy || 'Email not found', 
            timestamp: new Date(),
            reward_category: 'Worksheet_Download'
          });
        }



        // 3. Always record the download event in history (even if they exceeded the cap)
        await addDoc(collection(db, 'Downloads_And_Generations'), {
          userId: user.uid,
          email: user.email,
          action: 'Download',
          fileName: form.title,
          fileUrl: form.fileLink,
          subject: form.subject,
          type: form.type,
          standard: form.standard,
          device: currentDevice,
          timestamp: new Date()
        });

      } catch (error) {
        console.error("Error processing download metrics:", error);
      }
    }
  };

  {/* old code for download ignore
  const handleDownload = async (form) => {

    window.open(form.fileLink, '_blank');

    setFilteredForms(prev =>
      prev.map(f => f.id === form.id ? { ...f, downloads: f.downloads + 1 } : f)
    );

    const uploadRef = doc(db, 'uploads', form.id);
    await updateDoc(uploadRef, { downloads: increment(1) });

    const user = auth.currentUser;

    if (form.uid && form.uid !== user?.uid) {
  const creatorProfileRef = doc(db, 'public_profiles', form.uid);

  await setDoc(
    creatorProfileRef,
    { totalDownloads: increment(1) },
    { merge: true }
  );
}

    // 🔥 Grab the device type here!
        const currentDevice = getDeviceType();
    

      // Save download activity
  if (user) {
    await addDoc(collection(db, 'Downloads_And_Generations'), {
      userId: user.uid,
      email: user.email,
      action: 'Download',
      fileName: form.title,
      fileUrl: form.fileLink,
      subject: form.subject,
      type: form.type,
      standard: form.standard,
      device: currentDevice,
      timestamp: new Date()
    });
  }


  };

  */}
  

    useEffect(() => {
      const fetchProfileAndForms = async () => {
        const user = auth.currentUser;
        if (!user) {
          setLoadingForms(false);
          return;
        }

        setLoadingForms(true);

          try {
  
        const profileRef = doc(db, 'profiles', user.uid);
        const profileSnap = await getDoc(profileRef);
  
        if (profileSnap.exists()) {
          const parsedProfile = profileSnap.data();
          setProfile(parsedProfile);

          const standardFilter = getStandardFilter(parsedProfile);
          const schoolFilter = getSchoolFilter(parsedProfile);

          const shouldFetchUploads = selectedType !== 'AI_Quiz';
          const shouldFetchAiQuiz = selectedType === 'All Types' || selectedType === 'AI_Quiz';

          const uploadsList = [];
  
if (shouldFetchUploads) {
  const uploadsRef = collection(db, 'uploads');
  const uploadConstraints = [];

  if (selectedSubject !== 'All Subjects') {
    uploadConstraints.push(where('subject', '==', selectedSubject));
  }

  if (standardFilter) {
    uploadConstraints.push(where('standard', '==', standardFilter));
  }

  if (selectedType !== 'All Types') {
    uploadConstraints.push(where('type', '==', selectedType));
  }

  if (schoolFilter) {
    uploadConstraints.push(where('city', '==', schoolFilter.city));
    uploadConstraints.push(where('school', '==', schoolFilter.school));
  }

  uploadConstraints.push(orderBy(getUploadOrderField(), 'desc'));
  uploadConstraints.push(limit(firestoreFetchLimit));

  const querySnapshot = await getDocs(query(uploadsRef, ...uploadConstraints));

  querySnapshot.forEach((docSnap) => {
            const data = docSnap.data();
  
           //alert (data.topicName?.current );
  
            uploadsList.push({
              id: docSnap.id,
              uid: data.uid || '',
              title: data.calculatedFileName,
              fileLink: data.fileUrl,
              uploadedBy: data.uploadedBy || "User Not Found",
              creatorName: data.uploadername || "User Not Found",
              downloads: data.downloads || 0,
              
              shares: data.shares || 0,
              avgRating: data.avgRating || 0,
              numRatings: data.numRatings || 0,
              reportCount: data.reportCount || 0,
              reportedBy: data.reportedBy || {},
              uploadTime: data.uploadTime?.toDate?.() || null,
              subject: data.subject || "Other",
              type: data.type || "Worksheet",
              standard: data.standard || "N/A",
              school: data.school || "",
              city: data.city || "", // ✅ Added City fetch
              lessonName: data.lessonName || "Not Available",
              topics: Array.isArray(data.topicName?.current)
                  ? data.topicName.current.join(", ")
                  : String(data.topicName || "Not Available"),
            });
          });
        }

          // ==========================================
        // NEW ADDITION: Fetch AI_Results (Quizzes)
        // ==========================================
        try {
          
          if (shouldFetchAiQuiz) {
  const aiConstraints = [];

  if (selectedSubject !== 'All Subjects') {
    aiConstraints.push(where('subject', '==', selectedSubject));
  }

  if (standardFilter) {
    aiConstraints.push(where('standard', '==', standardFilter));
  }

  if (schoolFilter) {
    aiConstraints.push(where('school', '==', schoolFilter.school));
  }

  aiConstraints.push(orderBy(getAiOrderField(), 'desc'));
  aiConstraints.push(limit(firestoreFetchLimit));

  const quizzesQuery = query(collection(db, 'AI_Results'), ...aiConstraints);

          const quizzesSnapshot = await getDocs(quizzesQuery);
          quizzesSnapshot.forEach((docSnap) => {
            const data = docSnap.data();
            if (data.Quiz_Text && data.Quiz_Text !== 'No_Content') {
              uploadsList.push({
                id: docSnap.id,
                title: `${data.subject || 'Subject'} Quiz - ${data.topic || 'Topic'}`,
                fileLink: null, // Quizzes don't use file URLs
                uploadedBy: data.uploadername || "Eascode AI",
                creatorName: data.uploadername || "Eascode AI", 
                downloads: data.retake_count || 0,
                shares: 0,
                avgRating: 0,
                numRatings: 0,
                reportCount: 0,
                reportedBy: {},
                uploadTime: data.timestamp?.toDate?.() || null,
                subject: data.subject || "Other",
                type: "AI_Quiz", // Custom type for rendering
                standard: data.standard || "N/A",
                school: data.school || "",
                city: parsedProfile?.city || "", 
                lessonName: data.lesson || "Not Available",
                topics: data.topic || "Not Available",
                // Specific to AI Quiz
                Quiz_Text: data.Quiz_Text,
                format: data.format || "MCQ",
                score: data.score || 0,
                totalQuestions: data.totalQuestions || 0,
                originalQuizId: docSnap.id
              });
            }
          });
        }
        } catch (err) {
          console.error("Error fetching AI Quizzes:", err);
        }
        // ==========================================
  
          setAllForms(uploadsList);
          setFilteredForms(uploadsList);
  
          const feedbackPromises = uploadsList.map(async (form) => {
            const feedbackRef = doc(db, 'formFeedback', `form${form.id}`);
            const userVoteRef = doc(db, 'formFeedback', `form${form.id}_user_${user.uid}`);
            const [feedbackSnap, userVoteSnap] = await Promise.all([getDoc(feedbackRef), getDoc(userVoteRef)]);
  
            return {
              id: form.id,
              counts: feedbackSnap.exists() ? feedbackSnap.data() : { thumbsUp: 0, thumbsDown: 0 },
              vote: userVoteSnap.exists() ? userVoteSnap.data().vote : null,
            };
          });
  
          const results = await Promise.all(feedbackPromises);
          const counts = {};
          const votes = {};
          results.forEach(({ id, counts: c, vote }) => {
            counts[id] = c;
            votes[id] = vote;
          });
  
          setFeedbackCounts(counts);
          setUserVotes(votes);
        }
  
        //alert(profileSnap.id);
  
        {/*Replace downloaded with shared keep for future use*/}
        const downloadsRef = collection(db, 'Downloads_And_Generations');
        const q = query(downloadsRef, where('userId', '==', profileSnap.id));
  
        const snapshot = await getDocs(q);
        const fileIds = snapshot.docs.map(doc => doc.data().fileUrl); 
        // You’ll need to make sure each logged download has a fileId or fileName
        setDownloadedFileIds(fileIds);
  
        const sharedRef = collection(db, "Shared_Worksheets");
        const q_shared = query(sharedRef, where("friendEmail", "==", user.email));
        const snapshot_shared = await getDocs(q_shared);
  
        // ✅ Deduplicate using Set
        const shared_fileIds = [
          ...new Set(snapshot_shared.docs.map(doc => doc.data().fileUrl))
        ];
  
        setSharedFileIds(shared_fileIds);

} catch (error) {
    console.error("Error loading home resources:", error);
  } finally {
    setLoadingForms(false);
  }
};
  
      fetchProfileAndForms();
    }, [selectedSubject, selectedType, selectedSchool, selectedStandard, sortOption]);

    const handleStarRating = async (formId, rating) => {
      const user = auth.currentUser;
      if (!user) return alert("Please log in to rate.");
    
      setUserStarRatings(prev => ({ ...prev, [formId]: rating }));
    
      try {
        const ratingDocRef = doc(db, "formRatings", formId);
        const uploadDocRef = doc(db, "uploads", formId);
    
        const ratingSnap = await getDoc(ratingDocRef);
    
        let totalRating = 0;
        let numRatings = 0;
        let prevUserRating = 0;
    
        if (ratingSnap.exists()) {
          const data = ratingSnap.data();
          totalRating = data.totalRating || 0;
          numRatings = data.numRatings || 0;
          prevUserRating = data.userRatings?.[user.uid] || 0;
    
          const newTotalRating = totalRating - prevUserRating + rating;
          const newNumRatings = prevUserRating === 0 ? numRatings + 1 : numRatings;
          const avgRating = newNumRatings > 0 ? newTotalRating / newNumRatings : 0;
    
          await updateDoc(ratingDocRef, {
            totalRating: newTotalRating,
            numRatings: newNumRatings,
            [`userRatings.${user.uid}`]: rating,
            updatedAt: new Date()
          });
    
          // 🔥 Update uploads collection also
          await updateDoc(uploadDocRef, {
            totalRating: newTotalRating,
            numRatings: newNumRatings,
            avgRating: avgRating
          });
    
          // Update filteredForms
          setFilteredForms(prev =>
            prev.map(f =>
              f.id === formId
                ? { ...f, avgRating: avgRating, numRatings: newNumRatings }
                : f
            )
          );
    
          // 🔥 ALSO update allForms
          setAllForms(prev =>
            prev.map(f =>
              f.id === formId
                ? { ...f, avgRating: avgRating, numRatings: newNumRatings }
                : f
            )
          );
    
    
        } else {
          // First rating ever
          await setDoc(ratingDocRef, {
            totalRating: rating,
            numRatings: 1,
            userRatings: { [user.uid]: rating },
            createdAt: new Date(),
            updatedAt: new Date()
          });
    
          await updateDoc(uploadDocRef, {
            totalRating: rating,
            numRatings: 1,
            avgRating: rating
          });
    
          setFilteredForms(prev =>
            prev.map(f =>
              f.id === formId
                ? { ...f, avgRating: rating, numRatings: 1 }
                : f
            )
          );
        }
    
      } catch (error) {
        console.error("Error updating rating:", error);
      }
    };

     const handleReport = async (form) => {
      const user = auth.currentUser;
      if (!user) return alert("Please log in to report.");
    
      if (form.reportedBy?.[user.uid]) {
        return alert("You already reported this worksheet.");
      }
    
      const reason = prompt(
        "Reason:\n1. Incorrect Content\n2. Wrong Standard\n3. Offensive\n4. Other"
      );
    
      if (!reason) return;
    
      try {
        const uploadRef = doc(db, "uploads", form.id);
    
        await updateDoc(uploadRef, {
          reportCount: increment(1),
          [`reportedBy.${user.uid}`]: true
        });
    
        // Update UI immediately
        setAllForms(prev =>
          prev.map(f =>
            f.id === form.id
              ? {
                  ...f,
                  reportCount: (f.reportCount || 0) + 1,
                  reportedBy: {
                    ...f.reportedBy,
                    [user.uid]: true
                  }
                }
              : f
          )
        );
    
        setFilteredForms(prev =>
          prev.map(f =>
            f.id === form.id
              ? {
                  ...f,
                  reportCount: (f.reportCount || 0) + 1,
                  reportedBy: {
                    ...f.reportedBy,
                    [user.uid]: true
                  }
                }
              : f
          )
        );
    
        alert("Reported successfully.");
      } catch (error) {
        console.error("Report error:", error);
        alert("Failed to report.");
      }
    };

    // Update filteredForms based on filters and search
      useEffect(() => {
    const filtered = allForms.filter(form => {
    
      //alert (form.topics.toLowerCase().includes(searchQuery.toLowerCase()));
    
 const matchesSubject = selectedSubject === 'All Subjects' || form.subject === selectedSubject;
      const matchesType = selectedType === 'All Types' || form.type === selectedType;
      //alert(selectedType);
      //alert(form.type);
      
      // ✅ Crash-proof search matching Name OR Email
      const searchLower = (searchQuery || '').toLowerCase().trim();
      let matchesSearch = true;
      if (searchLower) {
        matchesSearch = 
          (form.creatorName || '').toLowerCase().includes(searchLower) || 
          (form.uploadedBy || '').toLowerCase().includes(searchLower) ||  
          (form.title || '').toLowerCase().includes(searchLower) || 
          (form.lessonName || '').toLowerCase().includes(searchLower) || 
          (form.topics || '').toLowerCase().includes(searchLower);
      }

// ✅ Updated logic to handle City, School combinations
      let matchesSchool = false;
      const formCitySchool = (form.city && form.school) ? `${form.city}, ${form.school}` : form.school;
      
      if (selectedSchool === 'My_School') {
        matchesSchool = form.school === profile?.school && form.city === profile?.city;
      } else if (selectedSchool === 'All_Schools') {
        matchesSchool = true;
      } else {
        // Matches the exact "City, School" the user selected from the dropdown
        matchesSchool = formCitySchool === selectedSchool; 
      }
    
// ✅ Updated Standard logic to handle 1-12
      let matchesStandard = false; 
      
      if (selectedStandard === 'All_Standard') {
        matchesStandard = true;
      } else if (selectedStandard === 'My_Standard') {
        // Safe check in case profile isn't loaded yet
        if (profile?.standard && String(form.standard) === String(profile.standard)) {
          matchesStandard = true;
        }
      } else if (String(form.standard) === String(selectedStandard)) {
        // Matches the exact number (1-12)
        matchesStandard = true;
      }
    
        // ✅ NEW: Shared filter
      let matchesShared = true;
      if (hideShared) {
        matchesShared = sharedFileIds.includes(form.fileLink);
      }

      {/*
      alert(matchesSchool);
      alert(matchesStandard);
      alert(matchesShared);
      alert(matchesSchool);
      alert(matchesSearch);
      alert(matchesType);
      alert(matchesSubject);
      */}
   
      return matchesSubject && matchesType && matchesSearch && matchesSchool && matchesStandard && matchesShared;
    });
    
    
     // Sort logic
    const sorted = [...filtered].sort((a, b) => {
      if (sortOption === 'newest') {
        return (b.uploadTime?.getTime?.() || 0) - (a.uploadTime?.getTime?.() || 0);
    
      } else if (sortOption === 'rating') {
      return (b.avgRating || 0) - (a.avgRating || 0);
    }
    else if (sortOption === 'downloads') {
        return b.downloads - a.downloads;
      }
    
      return 0;
    });
    
      
        setFilteredForms(sorted);
        setVisibleForms(sorted);
        //alert('all_forms'+allForms);
        setVisibleCount(pageSize); // ✅ Reset pagination to page 1
      }, [selectedSubject, selectedType, searchQuery, allForms, sortOption, feedbackCounts,selectedSchool,selectedStandard,sharedFileIds, hideShared   ]);
    
     
    

  {/************************************* */}



useEffect(() => {
    const fetchAlertsCount = async () => {
      const currentUser = auth.currentUser;
      if (!currentUser) return;

      try {
        // 1️⃣ Fetch Shared Worksheets
        const sharedQuery = query(
          collection(db, "Shared_Worksheets"),
          where("friendEmail", "==", currentUser.email)
        );
        const sharedSnapshot = await getDocs(sharedQuery);
        const sharedFileUrls = new Set();
        sharedSnapshot.docs.forEach((docSnap) => {
          if (docSnap.data().fileUrl) sharedFileUrls.add(docSnap.data().fileUrl);
        });

        // 1.5️⃣ Fetch Shared Quizzes
        const sharedQuizQuery = query(
          collection(db, "Shared_Quizzes"),
          where("friendEmail", "==", currentUser.email)
        );
        const sharedQuizSnapshot = await getDocs(sharedQuizQuery);
        sharedQuizSnapshot.docs.forEach((docSnap) => {
          // Quizzes lack a fileUrl, so we use their Document ID to track read receipts
          sharedFileUrls.add(docSnap.id);
        });

        // 2️⃣ Fetch Subscriptions
        const subQuery = query(
          collection(db, "subscriptions"),
          where("subscriberId", "==", currentUser.uid)
        );
        const subSnap = await getDocs(subQuery);
        
        const subMap = {}; 
        subSnap.docs.forEach((docSnap) => {
          const data = docSnap.data();
          subMap[data.creatorId] = data.timestamp?.seconds || 0;
        });
        const subscribedCreatorIds = Object.keys(subMap);

        // 3️⃣ Fetch Uploads for Subscribed Creators
        const subscribedFileUrls = new Set();
        if (subscribedCreatorIds.length > 0) {
          for (let i = 0; i < subscribedCreatorIds.length; i += 10) {
            const chunk = subscribedCreatorIds.slice(i, i + 10);
            const uQuery = query(collection(db, "uploads"), where("uid", "in", chunk));
            const uSnap = await getDocs(uQuery);

            uSnap.docs.forEach((docSnap) => {
              const data = docSnap.data();
              const uploadTimeSecs = data.uploadTime?.seconds || 0;
              const subTimeSecs = subMap[data.uid] || 0;

              if (uploadTimeSecs >= subTimeSecs && data.fileUrl) {
                subscribedFileUrls.add(data.fileUrl);
              }
            });
          }
        }

        // 4️⃣ Fetch Downloaded/Read items
        const downloadQuery = query(
          collection(db, "Downloads_And_Generations"),
          where("email", "==", currentUser.email)
        );
        const downloadSnapshot = await getDocs(downloadQuery);
        const downloadedFileUrls = new Set();
        downloadSnapshot.docs.forEach((docSnap) => {
          if (docSnap.data().fileUrl) downloadedFileUrls.add(docSnap.data().fileUrl);
        });

        // 5️⃣ Calculate total remaining un-downloaded alerts
        let remainingCount = 0;
        sharedFileUrls.forEach((identifier) => {
          if (!downloadedFileUrls.has(identifier)) remainingCount++;
        });
        subscribedFileUrls.forEach((fileUrl) => {
          if (!downloadedFileUrls.has(fileUrl)) remainingCount++;
        });

        setSharedCount(Math.max(0, remainingCount));

      } catch (error) {
        console.error("Error fetching alerts count:", error);
      }
    };

    fetchAlertsCount();
  }, []);

useEffect(() => {
  const state = location.state;
  if (state) {
    if (state.persona) setPersona(state.persona);
    //alert(persona);
    if (state.subject) setSubject(state.subject);
    if (state.selectedLessonId) {
      setSelectedLessonId(state.selectedLessonId);
      // find the matching lesson
      const selected = savedLessons.find(l => l.id === state.selectedLessonId);
      if (selected) {
        setText(selected.text || '');
        setLessonName(selected.lessonName || '');
      }
    }
  }
}, [location.state, savedLessons]);



  useEffect(() => {

    const fetchProfileAndFeedback = async () => {
      const user = auth.currentUser;
      if (!user) return;

      const profileRef = doc(db, 'profiles', user.uid);
      const schoolFeedbackRef = collection(db, 'schoolfeedbacks');

      try {
        const profileSnap = await getDoc(profileRef);

        if (profileSnap.exists()) {
          setProfileExists(true);
          const data = profileSnap.data();
          setUserName(data.name);
          setPersona(data.persona);
          //alert(persona);
          //alert(userName);
        } else {
          setProfileExists(false);
          navigate('/create-profile',{ state: { persona } });
        }

        const q = query(schoolFeedbackRef, where('uid', '==', user.uid));
        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
          setSchoolFeedbackExists(true);
        }
      } catch (error) {
        console.error("Error fetching profile or feedback:", error);
      }


      
    };

    fetchProfileAndFeedback();

  }, []);

useEffect(() => {
  const fetchRecentActivity = async () => {
    const currentUser = auth.currentUser;
    if (!currentUser) return;

    // --- Fetch AI Worksheets ---
    const worksheetsSnap = await getDocs(
      query(
        collection(db, "ai_image_generated_worksheets"),
        where("userId", "==", currentUser.uid)
      )
    );
    let worksheetsData = worksheetsSnap.docs
      .map(doc => ({
        id: doc.id,
        type: "AI Worksheet",
        subject: doc.data().subject,
        lesson: doc.data().lesson,
        timestamp: doc.data().timestamp?.toDate() || new Date(0),
        imageSrc: "/bot.png", // image from public folder
      }))
      .sort((a, b) => b.timestamp - a.timestamp)
      .slice(0, 10); // Take last 10 only

    // --- Fetch AI Quiz Results ---
    const quizzesSnap = await getDocs(
      query(
        collection(db, "AI_Results"),
        where("uid", "==", currentUser.uid)
      )
    );
    let quizzesData = quizzesSnap.docs
      .map(doc => ({
        id: doc.id,
        type: "AI Quiz",
        subject: doc.data().subject,
        lesson: doc.data().lesson,
        score: doc.data().score,
        totalQuestions: doc.data().totalQuestions,
        timestamp: doc.data().timestamp?.toDate() || new Date(0),
        imageSrc: "/ai_quiz.png", // image from public folder
      }))
      .sort((a, b) => b.timestamp - a.timestamp)
      .slice(0, 10); // Take last 10 only

    // --- Merge & sort the combined feed by timestamp descending ---
    const merged = [...worksheetsData, ...quizzesData].sort(
      (a, b) => b.timestamp - a.timestamp
    );

    setRecentActivity(merged);
  };

  fetchRecentActivity();
}, []);



  const handleNavigation = (path, state = {}) => {
    //alert(state.subject);
    //alert(state.selectedLessonId);
    //alert(state.type);
    navigate(path, { state });
    setIsDrawerOpen(false); // Close drawer on navigation
  };


  const [subjectList, setSubjectList] = useState([]);

  useEffect(() => {
    const fetchSubjects = async () => {
      try {
        if (!standard) return; // Don't fetch unless we have the user's standard
        if (!school) return; // Don't fetch unless we have the user's school

        let q = "";

        if(board === 'ICSE')
        {
          q = query(collection(db, 'Saved_lessons'), where('standard', '==', standard),
        where('school','==',school));
        }
        else{
          q = query(collection(db, 'lessons_raw'), where('standard', '==', Number(standard)));
        }

        const snapshot = await getDocs(q);
        const subjectsData = snapshot.docs.map(doc => doc.data().subject);
        // Deduplicate and sort
        const uniqueSortedSubjects = [...new Set(subjectsData)].sort();

        setSubjectList(uniqueSortedSubjects);
      } catch (error) {
        console.error('Error fetching subjects:', error);
      }
    };

    fetchSubjects();
  }, [standard,school]);




const handleLogout = async () => {
  const confirmLogout = window.confirm('Are you sure you want to log out?');
  if (!confirmLogout) return;

  try {
    await auth.signOut();
    sessionStorage.removeItem('eascode_chat_last_messages');
    alert('You have been logged out.');
    navigate('/login');
  } catch (error) {
    alert('Error logging out: ' + error.message);
  }
};

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  
    useEffect(() => {
    const fetchSavedLessons = async () => {
      const auth = getAuth();
      const user = auth.currentUser;
            if (!user) {
              alert("You must be logged in");
              navigate('/login');
            } else {
              setUser(user);
              const docRef = doc(db, 'profiles', user.uid);
              const docSnap = await getDoc(docRef);
              if (docSnap.exists()) {
                const profile = docSnap.data();
                setUserProfile(profile);

      const coreSubjects = ['English Language', 'Hindi Language', 'GK', 'Maths'];

    const snapshot = await getDocs(collection(db, 'Saved_lessons'));
    const lessons = snapshot.docs
      .map(doc => ({ id: doc.id, ...doc.data() }))
      .filter(item =>
        (item.email === user.email || item.sharedWith === 'parents') &&
        item.school === profile.school &&
        (
          coreSubjects.includes(item.subject) || 
          item.standard === profile.standard
        )
      );
      setSavedLessons(lessons);
      }
    }
    };
  
    fetchSavedLessons();
  }, []);
  

  
  useEffect(() => {
    const fetchProfileData = async () => {
      const user = getAuth().currentUser;
      if (!user) return;
  
      try {
        const profileRef = doc(db, 'profiles', user.uid);
        const profileSnap = await getDoc(profileRef);
        if (profileSnap.exists()) {
          const profile = profileSnap.data();
          setStandard(profile.standard || '');
          setSchool(profile.school || '');
          setboard(profile.board || 'ICSE')
        }
      } catch (err) {
        console.error('Failed to fetch profile data:', err);
      }

      // 🔹 1. Fetch all uploads
const uploadsQuery = query(
  collection(db, "uploads"),
  where("school", "==", school),
  where("standard", "==", standard),
  where("subject", "==", subject)
);

const uploadsSnap = await getDocs(uploadsQuery);
const allUploads = uploadsSnap.docs.map(doc => doc.data());

// 🔹 2. Fetch this user's downloads
const downloadsQuery = query(
  collection(db, "Downloads_And_Generations"),
  where("userId", "==", user.uid)
);

const downloadsSnap = await getDocs(downloadsQuery);
const userDownloadsRaw = downloadsSnap.docs.map(doc => doc.data());

// 🔹 Remove duplicate downloads (very important)
const uniqueDownloadedUrls = [
  ...new Set(userDownloadsRaw.map(d => d.fileUrl))
];

// 🔹 3. Build summary object
const summary = {};

allUploads.forEach(upload => {
  const key = upload.type;

  if (!summary[key]) {
    summary[key] = {
      type: upload.type,
      totalFiles: 0,
      totalDownloaded: 0,
      totalLeft: 0
    };
  }

  summary[key].totalFiles += 1;
});

// 🔹 Count downloaded
uniqueDownloadedUrls.forEach(url => {
  const matchedUpload = allUploads.find(u => u.fileUrl === url);

  if (matchedUpload) {
    const key = matchedUpload.type;
    if (summary[key]) {
      summary[key].totalDownloaded += 1;
    }
  }
});

// 🔹 Calculate totalLeft
Object.keys(summary).forEach(key => {
  summary[key].totalLeft =
    summary[key].totalFiles - summary[key].totalDownloaded;
});

setDownloadSummary(summary);
setLoadingSummary(false);

    };
  
    fetchProfileData();
  }, [subject]);

  //alert(savedLessons.length);

const getSummaryForType = (type) => {
  return downloadSummary[type] || {
    totalFiles: 0,
    totalDownloaded: 0,
    totalLeft: 0
  };
};

const aiSummary = getSummaryForType('AI_Worksheet');
const parentSummary = getSummaryForType('Worksheet');
const assessmentSummary = getSummaryForType('Assessment');

    const boardMessages = {
  ICSE: [
     "* Unfortunately we do not have any Lesson Based Subjects ready for your chosen school and standard.",
     '* You can add lessons using our "📎 Add a Lesson" tool below , or please reach out to us via the "❓ Get Support" Page in case you think this is not expected .',
     "* You can use the tool for Non-Lesson based subjects in the interim. Thanks"
  ],
  CBSE: [
    "*  We will use the NCERT books for all the lessons across chapters",
    '*  If you want to use non NCERT book you can add your lesson yourself using the "📎 Add a Lesson" button below.',
    "*  You can use the tool for Non-Lesson based subjects in the interim.",
  ],
    OTHERSTATE: [
    "*  We will use the NCERT books for all the lessons across chapters",
    '*  If you want to use non NCERT book you can add your lesson yourself using the "📎 Add a Lesson" button below.',
    "*  You can use the tool for Non-Lesson based subjects in the interim.",
  ],
};

const defaultMessages = [
     "* Unfortunately we do not have any Lesson Based Subjects ready for your chosen school and standard",
     '* You can add lessons using our "📎 Add a Lesson" tool below or please reach out to us via the "❓ Get Support" Page in case you think this is not expected .',
     "* You can use the tool for Non-Lesson based subjects in the interim.",
     "* Thanks"
];

// --- CAROUSEL COMPONENT ---
  const CityCarousel = ({ images, isMobile, city }) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
      if (!images || images.length === 0) return;
      const interval = setInterval(() => {
        setCurrentIndex((prev) => (prev + 1) % images.length);
      }, 7000);
      return () => clearInterval(interval);
    }, [images]);

    if (!images || images.length === 0) return null;

    return (
      <div className="w-full flex flex-col items-center bg-blue-50/50 py-3 md:py-6 px-4 rounded-xl md:rounded-2xl border border-blue-100 shadow-sm">
        {isMobile ? (
          <div className="w-full h-[180px] rounded-lg overflow-hidden relative shadow-md bg-white">
            <img src={images[currentIndex]} alt={`${city} Highlight`} className="w-full h-full object-cover transition-opacity duration-500 ease-in-out" key={currentIndex} />
          </div>
        ) : (
          <div className="w-full h-[220px] flex gap-4 overflow-hidden">
            {[0, 1, 2].map(offset => {
               const index = (currentIndex + offset) % images.length;
               return (
                 <div key={index} className="w-1/3 h-full rounded-xl overflow-hidden shadow-md bg-white shrink-0 transition-all duration-500 ease-in-out">
                   <img src={images[index]} alt={`${city} Highlight`} className="w-full h-full object-cover" />
                 </div>
               )
            })}
          </div>
        )}
      </div>
    );
  };

  // --- CHUNKING LOGIC ---
  const currentVisibleForms = visibleForms.slice(0, visibleCount);
  const formChunks = [];
  for (let i = 0; i < currentVisibleForms.length; i += pageSize) {
    formChunks.push(currentVisibleForms.slice(i, i + pageSize));
  }

  const handleRetakeQuiz = (form) => {
    navigate('/SameQuiz', {
      state: {
        Quiz_Text: form.Quiz_Text,
        subject: form.subject,
        topic: form.topics,
        format: form.format,
        standard: form.standard,
        lesson: form.lessonName,
        school: form.school,
        originalQuizId: form.originalQuizId
      }
    });
  };



return (
      <Layout
      profileExists={profileExists}
      userName={userName}
      persona={persona}
      handleNavigation={handleNavigation}
      handleLogout={handleLogout}
    >
    <div className="w-full max-w-full px-0 lg:px-1 pb-10 lg:pb-0 overflow-x-hidden">

   {/*   

      //Drop your reusable component here 
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'start' }}>
      <Help_Video 
        videoId="o6MIAVDIHwc?si=n1l6d7RWL0bIn8qm" // ⚠️ Replace with actual YouTube ID 
        title="How to use Voice to Text" 
      />
    </div>

   <br></br>

   */}



      {/* ================= HERO ================= */}
<div className="w-full max-w-full
                bg-white/80 backdrop-blur-md 
                border border-gray-200 
                rounded-2xl 
                px-1 py-2 md:px-1 md:py-1 
                mb-3
                shadow-sm hover:shadow-md
                transition-all duration-300">

  {/* HEADER */}
  <div className="flex items-center justify-between gap-3">

    {/* LEFT SIDE */}
    <div className="flex items-center gap-3 min-w-0">

 {/* USER AVATAR */}
      <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-blue-50 border border-blue-200 flex items-center justify-center overflow-hidden shadow-sm shrink-0">
        {profile?.avatarUrl ? (
          <img
            src={profile.avatarUrl}
            alt={userName || "User Avatar"}
            className="w-full h-full object-cover"
          />
        ) : (
          <User className="w-5 h-5 md:w-6 md:h-6 text-blue-400" />
        )}
      </div>
      

      <div className="leading-tight truncate">

        <h1 className="text-sm md:text-lg 
                       font-semibold text-gray-900 truncate">
          <span>Welcome, {userName || "Student"}</span>
        </h1>

        <p className="text-xs md:text-sm text-gray-500 truncate">
          <span>{school} · </span><br></br><span> Standard {standard}</span>
        </p>

      </div>

    </div>




      {/* RIGHT SIDE */}
    <div className="flex items-center gap-1 md:gap-3 flex-shrink-0">

{/* 🌐 STACKED LANGUAGE SELECTOR */}
      <div className="flex flex-col items-start bg-white px-1 py-1 rounded-lg shadow-sm border border-gray-100 min-w-fit">
        
        {/* Label on top */}
        <span className="text-[9px] md:text-xs text-gray-400 font-bold uppercase tracking-wider leading-none mb-0.5">
          <span>Language</span>
        </span>

        {/* Dropdown below */}
        <select
          value={browserLang}
          onChange={handleLanguageChange}
          className="text-xs md:text-sm
                     bg-transparent text-gray-800
                     font-bold
                     border-none outline-none
                     cursor-pointer
                     hover:text-blue-600
                     transition-colors duration-200
                     notranslate
                     p-0 m-0"
          translate="no"
        >
          <option value="as" className="notranslate">Assamese</option>
          <option value="bn" className="notranslate">Bengali</option>
          <option value="en" className="notranslate">English</option>
          <option value="gu" className="notranslate">Gujarati</option>
          <option value="hi" className="notranslate">Hindi</option>
          <option value="kn" className="notranslate">Kannada</option>
          <option value="ml" className="notranslate">Malayalam</option>
          <option value="or" className="notranslate">Odia</option>
          <option value="pa" className="notranslate">Punjabi</option>
          <option value="ta" className="notranslate">Tamil</option>
          <option value="te" className="notranslate">Telugu</option>
          <option value="ur" className="notranslate">Urdu</option>
        </select>
      </div>


      {/* 📊 PERFORMANCE */}
    {/*  <button
        onClick={() => {
          navigate("/UserQuizPerformance");
          trackClick("Show My Overall Quiz Performance");
        }}
        className="flex-shrink-0 flex items-center gap-1
                   px-2 md:px-4
                   py-2
                   rounded-full
                   bg-gray-100
                   text-gray-800
                   text-xs md:text-sm
                   font-medium
                   hover:bg-gray-200
                   hover:-translate-y-0.5
                   transition-all duration-200"
      >

        <span className="text-base">📊</span>

        <span className="hidden md:inline">
          My Performance
        </span>

      </button>  */}

    </div>

  </div>


<form
  onSubmit={askEasy}
  className="mt-2 flex w-full items-center gap-2"
  aria-label="Ask Easy"
>
  <input
    type="text"
    value={easyQuestion}
    onChange={(event) => setEasyQuestion(event.target.value)}
    maxLength={120000}
    placeholder="Tell Easy what you want to do Like make me a worksheet or a quiz…"
    aria-label="Message Easy"
    className="min-h-12 min-w-0 flex-1 rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm outline-none focus:border-indigo-500"
  />

  <button
    type="submit"
    disabled={!easyQuestion.trim()}
    aria-label="Ask Easy"
    className="flex min-h-12 min-w-12 items-center justify-center rounded-xl bg-indigo-600 px-3 text-white disabled:opacity-40"
  >
    <Send size={18} />
  </button>
</form>


{/* ================= QUICK ACTIONS ================= */}

  <div className="mt-2 pt-2">

    <div className="
      flex flex-wrap
      justify-center
      gap-1.5 sm:gap-4   {/* 1. Tighter gap on mobile */}
      lg:grid
      lg:grid-cols-5
      lg:gap-2
    ">

      {[
        {
          text: "Create Worksheet",
          path: board !== "ICSE"
            ? "/Eascode_Agent_Lesson_CBSE_NCERT"
            : "/Eascode_Agent_Lesson",
          icon: FilePlus,
          trackAction: "Create Worksheet Clicked"
        },
        {
          text: "Solve Quiz",
          path: board !== "ICSE"
            ? "/AIQuestionTest_CBSE_NCERT"
            : "/AIQuestionTest",
          icon: Brain,
          trackAction: "Solve Quiz Clicked"
        },
        // Tip: Shortening these slightly helps guarantee they fit on smaller phones!
        {
          text: "Composition", 
          path: "/CompositionHelp",
          icon: PenLine,
          trackAction: "Composition Clicked"
        },
    /*    { 
          text: "Discuss a Chapter", 
          path: "/ChapterChat",
          icon: Bot
        },
     */   {
          text: "Comprehension", 
          path: "/ComprehensionTool",
          icon: BookOpen,
          trackAction: "Comprehension Clicked"
        },
        {
          text: "Request a Worksheet", 
          path: "/RequestWorksheet",
          icon: Headset,
          trackAction: "RequestWorksheet Clicked"
        }
      ].map((btn, idx) => {

        const Icon = btn.icon;

        return (
          <button
            key={idx}
            onClick={() => {
              if (btn.trackAction) trackClick(btn.trackAction);
              handleNavigation(btn.path, { subject, selectedLessonId });
            }}
            className="
              w-auto lg:w-full
              flex items-center justify-center gap-1.5 md:gap-2
              px-2.5 py-1 md:px-3 md:py-1     {/* 2. Slightly less padding on mobile */}
              text-[10px] md:text-sm            {/* 3. Smaller text on mobile */}
              whitespace-nowrap                 {/* 4. Forces text onto one line */}
              rounded-full
              bg-gray-100
              text-gray-700
              hover:bg-gray-200
              hover:-translate-y-0.5
              active:scale-95
              transition-all duration-200
            "
          >
            <Icon className="w-3.5 h-3.5 md:w-5 md:h-5" /> {/* Smaller icon on mobile */}
            {btn.text}
          </button>
        );

      })}

    </div>

  </div>

</div>

          {/* ✅ Eascode Premium FLASH POPUP 
          {showRewardFlash && (
            <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/40 backdrop-blur-sm px-4">
              <div className="relative w-full max-w-md bg-white rounded-2xl shadow-2xl p-6 animate-[fadeIn_0.3s_ease-in-out]">
                
              <button
                onClick={() => {
                  sessionStorage.setItem("showPremiumCampaign", "false");
                  setShowRewardFlash(false);
                }}
                className="absolute top-1 right-1 text-gray-700 hover:text-gray-700 text-2xl font-bold"
              >
                X
              </button>

                <div className="flex justify-center items-center gap-6 mb-5">
                  <img
                    src="../Eascode_Premium_New.png"
                    alt="Eascode_Premium"
                    className="w-full h-full object-contain hover:scale-105 transition"
                    onClick={() => {
                      handleNavigation('/PremiumUpgradePage');
                      trackClick("Eascode Premium Clicked");
                    }}
                      />
                </div>

              </div>
            </div>
          )}  */}

{/*

      {showRewardFlash && (
  <div className="fixed inset-0 z-50 flex items-center justify-center 
                  bg-black/40 backdrop-blur-sm px-4">

    
    <div className="relative w-full max-w-md bg-white rounded-2xl 
                    shadow-2xl p-6 animate-[fadeIn_0.3s_ease-in-out]">

      
      <button
        onClick={() => setShowRewardFlash(false)}
        className="absolute top-3 right-4 text-gray-400 
                   hover:text-gray-700 text-2xl font-bold"
      >
        ×
      </button>

      
      <div className="flex justify-center items-center gap-6 mb-5">
        <img
          src="../Donate_Books.png"
          alt="Donate"
          className="w-20 h-20 object-contain hover:scale-105 transition"
        />

        <img
          src="../Request Books.png"
          alt="Request"
          className="w-20 h-20 object-contain hover:scale-105 transition"
        />
      </div>

      
      <h3 className="text-center text-lg font-semibold text-gray-700 mb-6">
        📚 Books Donation & Request Program 📚
      </h3>

      
      <button
        onClick={() => {
          setShowRewardFlash(false);
          handleNavigation('/BooksDonation');
          trackClick("Books Donation Clicked");
        }}
        className="w-full mb-3 bg-gradient-to-r 
                   from-green-500 to-emerald-600 
                   text-white py-3 rounded-xl 
                   font-medium shadow-md 
                   hover:shadow-lg hover:scale-[1.02] 
                   transition-all duration-200"
      >
        📦 Donate Books
      </button>

      
      <button
        onClick={() => {
          setShowRewardFlash(false);
          handleNavigation('/BooksRequest');
          trackClick("Books Request Clicked");
        }}
        className="w-full bg-gradient-to-r 
                   from-blue-500 to-indigo-600 
                   text-white py-3 rounded-xl 
                   font-medium shadow-md 
                   hover:shadow-lg hover:scale-[1.02] 
                   transition-all duration-200"
      >
        📖 Request Books
      </button>

    </div>
  </div>
)}

*/}

{/* ================= MAIN GRID ================= */}
{1===1 && (
  <div className="bg-white rounded-none md:rounded-2xl shadow-sm p-2 md:p-4 mb-8 border-x-0 md:border-x"> {/* single column grid */}

   
    <div className="grid grid-cols-1 gap-8"> {/* single column grid */}

      {/* ================= DOWNLOAD WORKSHEETS ================= */}
      <div>

{/* 1. Header & Clear Filters Row */}
        <div className="flex justify-between items-center px-1 mb-3">
          <h3 className="text-base md:text-xl font-bold text-gray-800">Search Worksheets, Quiz & Creators</h3>
          <button 
            onClick={() => {
              setSearchQuery(''); 
              setSortOption('newest'); 
              setSelectedSubject('All Subjects');
              setSelectedType('All Types');
              setSelectedStandard('All_Standard'); // ✅ Now opens up to ALL standards!
              setSelectedSchool('All_Schools');    // ✅ Now opens up to ALL schools!
              setHideShared(false);
            }}
            className="text-[10px] md:text-xs text-blue-600 hover:text-blue-800 font-semibold underline"
          >
            Clear Filters
          </button>
        </div>

        {/* Filters */}
        <div className="flex flex-wrap gap-1 mb-6 justify-between items-center">

        {/* ================= SEARCH & SORT ROW (FULL WIDTH, SINGLE LINE) ================= */}
        <div className="flex flex-row w-full gap-1.5 md:gap-3 mb-1.5 md:mb-2 items-center justify-between">

          {/* 1. Search Bar (flex-1 forces it to stretch and take maximum space) */}
          <div ref={searchWrapperRef} className="relative flex-1 min-w-0">
            <input
              type="text"
              placeholder="Search by creator, title, topics..."
              value={searchQuery}
              onChange={handleSearchChange}
              className="w-full px-2.5 py-1.5 md:px-3 md:py-2 border rounded-lg border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-400 bg-white shadow-sm text-[11px] md:text-sm truncate"
            />
            


            {/* THE DROPDOWN */}
            {suggestions.length > 0 && (
              <div className="absolute z-50 w-full bg-white border border-gray-200 rounded-xl mt-1 shadow-2xl max-h-80 overflow-y-auto animate-fadeIn">
                <div className="px-4 py-2 text-[10px] uppercase tracking-wider font-bold text-gray-400 bg-gray-50 border-b">
                  Creator Storefronts
                </div>
{suggestions.map((creator) => (
                  <div
                    key={creator.id}
                    onClick={() => handleSelectSuggestion(creator)}
                    className="flex items-center gap-3 p-2 md:p-3 hover:bg-blue-50 cursor-pointer border-b last:border-0 transition-colors"
                  >
                    <div className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-blue-100 flex items-center justify-center overflow-hidden border border-blue-200 shrink-0">
                      {creator.avatarUrl ? (
                        <img src={creator.avatarUrl} alt={creator.displayName} className="w-full h-full object-cover" />
                      ) : (
                        <User className="w-4 h-4 md:w-5 md:h-5 text-blue-500" />
                      )}
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="font-bold text-xs md:text-sm text-gray-800 truncate">{creator.displayName}</div>
                      <div className="text-[9px] md:text-[10px] text-gray-500 truncate mt-0.5">
                        {/* ✅ Added Standard to Dropdown! */}
                        {[creator.city, creator.school, creator.standard ? `Std ${creator.standard}` : null].filter(Boolean).join(' • ')}
                      </div>
                    </div>
                    <span className="text-blue-400 text-[9px] md:text-[10px] font-bold mr-2 uppercase">Visit ›</span>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* 2. Sort Dropdown (shrink-0 keeps it from getting squished) */}
          <div className="shrink-0">
            <select
              value={sortOption}
              onChange={(e) => setSortOption(e.target.value)}
              className="px-1.5 py-1.5 md:px-3 md:py-2 border rounded-lg border-gray-300 text-[10px] md:text-sm font-medium focus:outline-none focus:ring-2 focus:ring-blue-400 bg-white shadow-sm cursor-pointer"
            >
              <option value="newest">Newest</option>
              <option value="rating">Top Rated</option>
              <option value="downloads">Downloads</option>
            </select>
          </div>

          {/* 3. Checkbox Toggle (shrink-0 keeps it from getting squished) */}
          <label className="shrink-0 flex items-center gap-1.5 md:gap-2 bg-white px-2 py-1.5 md:px-3 md:py-2 rounded-lg border border-gray-200 cursor-pointer hover:bg-gray-50 transition-colors shadow-sm">
            <input
              type="checkbox"
              checked={hideShared}
              onChange={(e) => setHideShared(e.target.checked)}
              className="w-3 h-3 md:w-4 md:h-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
            />
            <span className="text-[10px] md:text-sm font-medium text-gray-700 whitespace-nowrap">
              {/* Pro-Tip: Hide "with Me" on small screens to save space! */}
              <span className="hidden sm:inline">Shared with Me</span>
              <span className="sm:hidden">Shared</span>
            </span>
          </label>

        </div>
        </div>



{/* ================= Sticky Filters ================= */}
        <div className="sticky top-16 z-40 bg-white border-b border-gray-200 pt-1 pb-2 md:pt-1 md:pb-2 mb-4 md:mb-6">
          
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 md:gap-4">

            {/* 1. Subject */}
            <div className="flex flex-col">
              <label className="text-[10px] md:text-xs font-semibold text-gray-600 mb-0.5 md:mb-1">Subject</label>
              <select
                value={selectedSubject}
                onChange={(e) => setSelectedSubject(e.target.value)}
                className="w-full px-2 md:px-3 py-1.5 md:py-2 border rounded-md md:rounded-lg border-gray-300 text-[10px] md:text-sm focus:outline-none focus:ring-2 focus:ring-blue-400 truncate bg-white"
              >
                {subjects.map(sub => (<option key={sub} value={sub}>{sub}</option>))}
              </select>
            </div>

            {/* 2. Type */}
            <div className="flex flex-col">
              <label className="text-[10px] md:text-xs font-semibold text-gray-600 mb-0.5 md:mb-1">Type</label>
              <select
                value={selectedType}
                onChange={(e) => setSelectedType(e.target.value)}
                className="w-full px-2 md:px-3 py-1.5 md:py-2 border rounded-md md:rounded-lg border-gray-300 text-[10px] md:text-sm focus:outline-none focus:ring-2 focus:ring-blue-400 truncate bg-white"
              >
                <option value="All Types">All Types</option>
                <option value="AI_Worksheet">AI Worksheets</option>
                <option value="Worksheet">Parent Worksheets</option>
                <option value="Assessment">School Assessment</option>
                <option value="AI_Quiz">AI Quiz</option>
              </select>
            </div>

            {/* 3. Standard (Now with 1-12 loop!) */}
            <div className="flex flex-col">
              <label className="text-[10px] md:text-xs font-semibold text-gray-600 mb-0.5 md:mb-1">Standard</label>
              <select
                value={selectedStandard}
                onChange={(e) => setSelectedStandard(e.target.value)}
                className="w-full px-2 md:px-3 py-1.5 md:py-2 border rounded-md md:rounded-lg border-gray-300 text-[10px] md:text-sm focus:outline-none focus:ring-2 focus:ring-blue-400 truncate bg-white"
              >
                <option value="All_Standard">All Standards</option>
                <option value="My_Standard">My Standard</option>
                {[...Array(12)].map((_, i) => (
                  <option key={i + 1} value={String(i + 1)}>Standard {i + 1}</option>
                ))}
              </select>
            </div>

{/* 4. City, School (Now with Dynamic List!) */}
            <div className="flex flex-col">
              <label className="text-[10px] md:text-xs font-semibold text-gray-600 mb-0.5 md:mb-1">City, School</label>
              <select
                value={selectedSchool}
                onChange={(e) => setSelectedSchool(e.target.value)}
                className="w-full px-2 md:px-3 py-1.5 md:py-2 border rounded-md md:rounded-lg border-gray-300 text-[10px] md:text-sm focus:outline-none focus:ring-2 focus:ring-blue-400 truncate bg-white"
              >
                <option value="My_School">My School</option>
                <option value="All_Schools">All Schools</option>
                <optgroup label="Specific Schools">
                  {uniqueCitySchools.map(citySchoolName => {
                    const myCitySchool = (profile?.city && profile?.school) ? `${profile.city}, ${profile.school}` : profile?.school;
                    return citySchoolName !== myCitySchool && (
                      <option
  key={citySchoolName}
  value={citySchoolName}
  style={schoolsWithForms.has(citySchoolName) ? {
    backgroundColor: '#dcfce7',
    color: '#166534',
    fontWeight: 600
  } : {}}
>
  {schoolsWithForms.has(citySchoolName) ? `✓ ${citySchoolName}` : citySchoolName}
</option>

                    );
                  })}
                </optgroup>
              </select>
            </div>

          </div>
        </div>

{loadingForms ? (
  <div
    role="status"
    aria-live="polite"
    className="w-full flex flex-col justify-center items-center h-48 gap-3 bg-white rounded-2xl border border-gray-100 shadow-sm"
  >
    <div className="h-8 w-8 rounded-full border-4 border-blue-100 border-t-blue-600 animate-spin" />
    <p className="text-gray-500 text-xs md:text-sm font-medium">
      Loading your learning resources...
    </p>
  </div>
) : (
  <>

{/* ================= FORMS GRID (CHUNKED WITH BANNERS) ================= */}
        <div className="w-full flex flex-col">
          {formChunks.map((chunk, chunkIndex) => (
            <React.Fragment key={`chunk-${chunkIndex}`}>

 {/*             {carouselImages.length > 0 && chunkIndex > 0 && (
  <div className="mb-8 px-1 w-full overflow-hidden rounded-2xl bg-gray-50 border border-gray-100 relative">
    // Injecting CSS directly for the infinite loop 
    <style>
      {`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee-infinite {
          display: flex;
          width: max-content;
          animation: marquee 30s linear infinite;
        }
        .animate-marquee-infinite:hover {
          animation-play-state: paused;
        }
      `}
    </style>

    <div className="relative h-[300px] md:h-[300px] lg:h-[400px] flex items-center">
      <div className="animate-marquee-infinite flex gap-4 p-2">
        // Doubling the array ensures the loop never breaks 
        {[...carouselImages, ...carouselImages].map((banner, index) => (
          <a 
            key={`banner-${chunkIndex}-${index}`}
            href={banner.link}
            target="_blank" 
            rel="noopener noreferrer"
            className="w-[45vw] md:w-[31vw] lg:w-[31vw] h-full flex-shrink-0 block"
          >
            <img 
              src={banner.image} 
              alt="Promotion" 
              className="w-full h-full object-cover rounded-xl shadow-sm border border-white hover:scale-[1.02] transition-transform duration-300" 
            />
          </a>
        ))}
      </div>
    </div>
  </div>
)}
*/}
              <div className="grid grid-cols-2 lg:grid-cols-3 gap-2 md:gap-4 lg:h-auto lg:overflow-visible lg:snap-none w-full">
              {chunk.map(form => (
  //<div key={form.id} className={`bg-white rounded-2xl shadow-md hover:shadow-xl transition overflow-hidden border flex flex-col ${form.type === 'AI_Quiz' ? 'col-span-1 lg:col-span-1' : 'col-span-2 lg:col-span-1'}`}>
  <div key={form.id} className={`rounded-2xl shadow-md hover:shadow-xl transition overflow-hidden border flex flex-col ${form.type === 'AI_Quiz' ? 'col-span-1 lg:col-span-1' : 'col-span-2 lg:col-span-1'} ${form.reportCount > 0 ? 'bg-red-50 border-red-300' : 'bg-white'}`}>  
  {/* File Name */}
                    <h3 className="px-3 pt-2 font-semibold text-gray-800 text-sm line-clamp-2 leading-snug break-all" title={form.title}>
                      {form.title}
                    </h3>

                {/* File Preview */}
                    <div
                      className="bg-gray-100 flex items-center justify-center h-[400px] lg:h-[450px] relative overflow-hidden"
                      //onContextMenu={(e) => e.preventDefault()}
                    >
                      {form.type === 'AI_Quiz' ? (
                        <div className="w-full h-full bg-slate-50 p-4 overflow-y-auto relative text-left">
                          {/* Sticky Header */}
                          <div className="sticky top-0 bg-slate-50/95 backdrop-blur-sm pb-2 mb-3 border-b border-slate-200 z-10 flex justify-between items-end">
                            <span className="font-bold text-indigo-700 text-sm">Quiz Preview</span>
                            <span className="text-[10px] font-bold bg-indigo-100 text-indigo-800 px-2 py-1 rounded-md">
                              {form.totalQuestions} Questions
                            </span>
                          </div>

                          {/* Questions List */}
                          <div className="space-y-3 pb-4">
                            {form.Quiz_Text && form.Quiz_Text !== 'No_Content' ? (
                              form.Quiz_Text.split('\n\n').map((block, idx) => {
                                const lines = block.split('\n');
                                const qLine = lines.find(l => l.toLowerCase().startsWith('question:'));
                                const optionsLine = lines.find(l => l.toLowerCase().startsWith('options:'));

                                if (!qLine) return null;

                                return (
                                  <div key={idx} className="bg-white p-3 rounded-xl shadow-sm border border-slate-200">
                                    <p className="font-bold text-slate-800 text-[11px] leading-snug">
                                      <span className="text-indigo-500 mr-1">{idx + 1}.</span> 
                                      {qLine.replace(/question:/i, '').trim()}
                                    </p>
                                    
                                    {optionsLine && (
                                      <div className="mt-2 space-y-1">
                                        {optionsLine.replace(/options:/i, '').split('|').map((opt, i) => (
                                          <div key={i} className="text-[10px] text-slate-600 bg-slate-50 px-2 py-1.5 rounded-md border border-slate-100">
                                            {String.fromCharCode(65 + i)}. {opt.trim()}
                                          </div>
                                        ))}
                                      </div>
                                    )}
                                  </div>
                                );
                              })
                            ) : (
                              <div className="text-xs text-slate-500 text-center mt-10">No questions available to preview.</div>
                            )}
                          </div>
                          
                          {/* Fade out effect at the bottom for aesthetics */}
                          <div className="sticky bottom-0 left-0 right-0 h-8 bg-gradient-to-t from-slate-50 to-transparent pointer-events-none"></div>
                        </div>
                      ) : form.fileLink?.toLowerCase().includes(".pdf") ? (
                        isMobile ? (
                          <iframe
                            src={`https://docs.google.com/gview?url=${encodeURIComponent(form.fileLink)}&embedded=true`}
                            title="preview"                            
                            className="w-full h-full"
                          />
                        ) : (
                          <iframe
                            src={`${form.fileLink}#toolbar=0&navpanes=0&scrollbar=1`}
                            title="preview"                            
                            className="w-full h-full"
                          />
                        )
                      ) : (
                        <img
                          src={form.fileLink}
                          alt="preview"                          
                          className="object-cover w-full h-full"
                        />
                      )}
                    </div>



                    {/* Details Dropdown */}
                    <div className="border rounded-xl bg-white shadow-sm m-2">
                      <button
                        onClick={() => setOpenId(openId === form.id ? null : form.id)}
                        className="w-full flex items-center justify-between px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 rounded-xl"
                      >
                        <span>Details</span>
                        <ChevronDown
                          className={`w-4 h-4 transition-transform duration-300 ${
                            openId === form.id ? "rotate-180" : ""
                          }`}
                        />
                      </button>

                      <div
                        className={`overflow-hidden transition-all duration-300 ${
                          openId === form.id ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
                        }`}
                      >
<div className="px-3 pb-3 pt-1 text-xs text-gray-600 space-y-1">
                          {/* ✅ Shows ONLY the Creator Name */}
                          <p className="font-bold text-blue-600"><span>Creator: {form.creatorName}</span></p>
                          <p className="mt-1"><span>Lesson: {form.lessonName}</span></p>
                          <p><span>Type: {form.type}</span></p>
                          <p><span>School: {form.city ? `${form.city}, ${form.school}` : form.school}</span></p>
                          <p><span>Standard: {form.standard}</span></p>
                          <p><span>Topics: {form.topics}</span></p>
                          {form.uploadTime && <p><span>Uploaded on: {form.uploadTime.toLocaleDateString()}</span></p>}
                        </div>

                        <button
                          onClick={() => handleReport(form)}
                          disabled={form.reportedBy?.[auth.currentUser?.uid]}
                          className="flex-1 ml-2 mb-2 bg-red-300 hover:bg-blue-600 text-black py-2 px-3 rounded-full text-xs"
                        >
                          <span>
                            {form.reportedBy?.[auth.currentUser?.uid]
                              ? `Reported (${form.reportCount || 0})`
                              : `Report (${form.reportCount || 0})`}
                          </span>
                        </button>
                      </div>
                    </div>

                    {/* User Reviews & Rating */}
                    <div className="px-3 pb-2 pt-1 text-sm border-t border-gray-200">
                      <h4 className="font-semibold mb-1 text-gray-700">User Reviews & Rating</h4>
                      <div className="flex items-center justify-between text-xs mb-1">
                        <span className="text-gray-600">Average Rating:</span>
                        <span className="font-bold text-gray-800">
                          <span>{form.avgRating?.toFixed(1) || '0.0'} ⭐</span>
                        </span>
                      </div>
                      <div className="flex items-center gap-1">
                        {[1, 2, 3, 4, 5].map(star => (
                          <span
                            key={star}
                            onClick={() => handleStarRating(form.id, star)}
                            className={`cursor-pointer ${(userStarRatings[form.id] || 0) >= star ? 'text-yellow-400' : 'text-gray-300'}`}
                          >
                            ★
                          </span>
                        ))}
                        <span className="text-gray-500 text-xs ml-2">(Click to rate)</span>
                      </div>
                    </div>

{/* Buttons */}
                    <div className="px-3 pb-3 flex flex-wrap gap-2 mt-2">
                      {form.reportCount > 0 ? (
                        <button
                          disabled
                          className="flex-1 bg-red-200 text-red-800 py-2 px-3 rounded-full text-xs font-bold cursor-not-allowed opacity-80"
                        >
                          <span>Under Review</span>
                        </button>
                      ) : form.type === 'AI_Quiz' ? (
                        <>
                        <button
                          onClick={() => handleRetakeQuiz(form)}
                          className="flex-1 bg-indigo-600 hover:bg-indigo-700 text-white py-2 px-3 rounded-full text-xs font-bold transition shadow-sm"
                        >
                          <span>Take Quiz</span>
                        </button>

                        </>
                      ) : (
                        <>
                      <button
                        onClick={() => handleDownload(form)}
                        className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-800 py-2 px-3 rounded-full text-xs font-medium transition"
                      >
                        <span>Download {form.downloads}</span>
                      </button>

                      <button
                        onClick={() => navigate("/Email_Worksheet", { state: { fileId: form.id } })}
                        className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-800 py-2 px-3 rounded-full text-xs font-medium transition"
                      >
                        <span>Share {form.shares}</span>
                      </button>
                      </>
                      )}
                    </div>

                    <div className="px-2 mt-1 mb-2 flex items-center gap-2 whitespace-nowrap text-[11px]">
                      {downloadedFileIds.includes(form.fileLink) && (
                        <span className="bg-green-100 text-green-700 px-2 py-0.5 rounded">
                          ✔ Already Downloaded
                        </span>
                      )}
                    </div>

                  </div>
                ))}
              </div>
            </React.Fragment>
          ))}
        </div>

  </>
)}

                {/* SHOW ME MORE BUTTON */}
{!loadingForms && visibleForms.length > 0 && (
  <div className="mt-6 md:mt-8 flex justify-center">
    {visibleCount < visibleForms.length ? (
      <button
        onClick={() => setVisibleCount(prev => prev + pageSize)}
        className="bg-white border-2 border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white px-6 md:px-8 py-2 md:py-3 rounded-full font-bold text-xs md:text-sm shadow-sm transition-all duration-300"
      >
        Show me more
      </button>
    ) : (
      <p className="text-xs md:text-sm text-gray-400 font-medium">
        No more resources
      </p>
    )}
  </div>
)}



{/* ALWAYS VISIBLE CIRCULATING CAROUSEL */}
{carouselImages.length > 0 && (
  <div className="mb-8 px-1 w-full overflow-hidden rounded-2xl bg-gray-50 border border-gray-100 relative">
    {/* Injecting CSS directly for the infinite loop */}
    <style>
      {`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee-infinite {
          display: flex;
          width: max-content;
          animation: marquee 30s linear infinite;
        }
        .animate-marquee-infinite:hover {
          animation-play-state: paused;
        }
      `}
    </style>

    <div className="relative h-[200px] md:h-[350px] lg:h-[350px] flex items-center">
      <div className="animate-marquee-infinite flex gap-4 p-2">
        {/* Doubling the array ensures the loop never breaks */}
        {[...carouselImages, ...carouselImages].map((banner, index) => (
          <a 
            key={`banner-${index}`}
            href={banner.link}
            target="_blank" 
            rel="noopener noreferrer"
            className="w-[45vw] md:w-[31vw] lg:w-[31vw] h-full flex-shrink-0 block"
          >
            <img 
              src={banner.image} 
              alt="Promotion" 
              className="w-full h-full object-cover rounded-xl shadow-sm border border-white hover:scale-[1.02] transition-transform duration-300" 
            />
          </a>
        ))}
      </div>
    </div>
  </div>
)}




      </div>

      </div>

      </div>
)}

      {1===1 && (
  <div className="bg-white rounded-2xl shadow-sm p-4 mb-8"> {/* single column grid */}

      <div className="bg-white rounded-2xl shadow-sm p-4 mb-8">

{/* ================= UPLOAD & HELP ================= */}
<div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-6">

  {/* UPLOAD */}
  <div className="bg-white border border-gray-200 rounded-xl shadow-sm p-3">
    
    <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">
      📤 Upload
    </h3>

    <div className="space-y-1">

      <button
        onClick={() => handleNavigation('/VoicetoText', { subject, selectedLessonId })}
        className="w-full flex items-center gap-3 p-2 rounded-lg hover:bg-gray-50 transition"
      >
        <img src="/Add_Lesson.png" className="w-7 h-7 object-contain" />
        <div className="text-left leading-tight">
          <p className="text-sm font-medium text-gray-800">
            Add a Lesson
          </p>
          <p className="text-[11px] text-gray-500">
            All Uploads will be Validated by our team
          </p>
        </div>
      </button>

      

      <button
        onClick={() => handleNavigation('/AddWorksheet', { subject, selectedLessonId })}
        className="w-full flex items-center gap-3 p-2 rounded-lg hover:bg-gray-50 transition"
      >
        <img src="/Parent_Worksheet.png" className="w-7 h-7 object-contain" />
        <div className="text-left leading-tight">
          <p className="text-sm font-medium text-gray-800">
            Add a Worksheet
          </p>
          <p className="text-[11px] text-gray-500">
            All Uploads will be Validated by our team
          </p>
        </div>
      </button>

    

      {(user?.email || auth.currentUser?.email) === 'eascode.ltd@gmail.com' && (
        <button
          onClick={() => handleNavigation('/Approved_User_Submissions')}
          className="w-full flex items-center gap-3 p-2 rounded-lg hover:bg-gray-50 transition"
        >
          <img src="/support.png" alt="" className="w-7 h-7 object-contain" />
          <div className="text-left leading-tight">
            <p className="text-sm font-medium text-gray-800">
              Approve User Submissions
            </p>
            <p className="text-[11px] text-gray-500">
              Review pending lessons and uploads
            </p>
          </div>
        </button>
      )}

    </div>
  </div>

  {/* HELP */}
  <div className="bg-white border border-gray-200 rounded-xl shadow-sm p-3">

    <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">
      🆘 Help
    </h3>

    <div className="space-y-1">

      <button
        onClick={() => handleNavigation('/Support')}
        className="w-full flex items-center gap-3 p-2 rounded-lg hover:bg-gray-50 transition"
      >
        <img src="/support.png" className="w-7 h-7 object-contain" />
        <div className="text-left leading-tight">
          <p className="text-sm font-medium text-gray-800">
            Get Support
          </p>
          <p className="text-[11px] text-gray-500">
            Help or questions
          </p>
        </div>
      </button>

      <button
        onClick={() => handleNavigation('/RequestWorksheet')}
        className="w-full flex items-center gap-3 p-2 rounded-lg hover:bg-gray-50 transition"
      >
        <img src="/help.png" className="w-7 h-7 object-contain" />
        <div className="text-left leading-tight">
          <p className="text-sm font-medium text-gray-800">
            Request Worksheet
          </p>
          <p className="text-[11px] text-gray-500">
            Ask for new worksheet from Eascode
          </p>
        </div>
      </button>

    </div>
  </div>

</div>

    </div>

  </div>
)}

      {/* FOOTER */}
      <div className="mt-12 text-center text-sm text-gray-500">
        © 2026 Eascode All Rights Reserved.
      </div>

    </div>


    

    {showEasyIntro && (
  <>
  <div className="fixed inset-0 z-[90] flex items-center justify-center bg-black/30 px-4">
    <div className="easy-ai-balloon relative max-w-xs sm:max-w-sm bg-white rounded-3xl shadow-2xl border border-blue-100 p-5 text-center">
      <button
        type="button"
        onClick={() => setShowEasyIntro(false)}
        aria-label="Close Easy intro"
        className="absolute top-2 right-3 text-slate-400 hover:text-slate-700 text-lg font-bold"
      >
        X
      </button>

      <div className="mx-auto w-24 h-24 rounded-full bg-white border border-blue-100 shadow-lg flex items-center justify-center mb-4">
        <img
          src="/Eascode_No_Background.png"
          alt="Easy AI Assistant"
          className="w-full h-full object-contain rounded-full"
        />
      </div>

      <p className="text-sm font-black text-blue-600 mb-2 ">
        Easy
      </p>

      <h2 className="text-xl font-black text-slate-900 mb-2">
        Meet Easy
      </h2>

      <p className="text-sm font-semibold text-slate-600 leading-relaxed">
        Easy is your personal AI Powered Study Assistant. It answers your questions related to chapters, topics and your performance.
        It makes worksheets and quiz too.
      </p>

      <button
        type="button"
        onClick={() => {
          setShowEasyIntro(false);
          trackClick("Easy Clicked");
          handleNavigation("/EasyUnifiedChat");
        }}
        className="mt-4 w-full rounded-xl bg-blue-600 text-white py-2.5 text-sm font-bold shadow-md"
      >
        Ask Easy
      </button>
    </div>
  </div>
  <style>{`
    @keyframes easyBalloonIn {
      0% {
        transform: scale(0.15);
        opacity: 0;
        border-radius: 9999px;
      }
      60% {
        transform: scale(1.08);
        opacity: 1;
        border-radius: 28px;
      }
      100% {
        transform: scale(1);
        opacity: 1;
        border-radius: 24px;
      }
    }

    .easy-ai-balloon {
      animation: easyBalloonIn 0.65s ease-out;
    }
  `}</style>
  </>
)}

  </Layout>
);
}





function SectionCard({ title, children }) {
  return (
    <div>
      <h3 className="text-xl font-semibold text-gray-800 mb-4">{title}</h3>
      <div className="bg-white rounded-2xl shadow-sm overflow-hidden">
        {children}
      </div>
    </div>
  );
}

function ListItem({ imageSrc, bgColor, title, subtitle, onClick }) {
  return (
    <div
      onClick={onClick}
      className="flex items-center justify-between p-4 bg-white rounded-2xl shadow-sm hover:shadow-md transition cursor-pointer"
    >
      <div className="flex items-center gap-4">

        {/* 👇 THIS is where the class goes */}
        <div className={`w-12 h-12 rounded-full ${bgColor} flex items-center justify-center shadow-inner`}>
          <img
            src={imageSrc}
            alt={title}
            className="w-20 h-20 object-contain"
          />
        </div>

        <div>
          <h4 className="font-semibold text-gray-800">{title}</h4>
          <p className="text-sm text-gray-500">{subtitle}</p>
        </div>

      </div>

      <span className="text-gray-400 text-xl">›</span>
    </div>
  );
}




export default Old_Home;
